import type { RowGroup } from "./types";
import type { Dispatch } from "react";
import type { EditorAction } from "../editor/reducers";
import { mdiTableRowHeight } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { TableEditorStep } from "./TableEditorStep";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@acdc2/ui/components/select";

type Props = {
  dispatch: Dispatch<EditorAction>;
  soleTableGroup: RowGroup | undefined;
  isSelectionRectangular: boolean;
  isSelectionFullWidth: boolean;
  isTopRowSelected: boolean;
  isBottomRowSelected: boolean;
};

export function TableEditorStep7({
  dispatch,
  soleTableGroup,
  isSelectionRectangular,
  isSelectionFullWidth,
  isTopRowSelected,
  isBottomRowSelected,
}: Props) {
  const { t } = useTranslation();

  return (
    <TableEditorStep
      value="step7"
      iconPath={mdiTableRowHeight}
      title={t("TableEditorStep7.title")}
      description={t("TableEditorStep7.description")}
    >
      <Select
        disabled={!isSelectionRectangular || !isSelectionFullWidth}
        value={soleTableGroup ?? ""}
        onValueChange={(newValue) => {
          if (!newValue) return;
          dispatch({
            type: "updateTableRowGroups",
            group: newValue as RowGroup,
          });
        }}
      >
        <SelectTrigger className="w-full">
          <SelectValue
            placeholder={t("TableEditorStep7.inputs.group.placeholder")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="thead" disabled={!isTopRowSelected}>
            {t("TableEditorStep7.inputs.group.labels.thead")}
          </SelectItem>
          <SelectItem value="tbody">
            {t("TableEditorStep7.inputs.group.labels.tbody")}
          </SelectItem>
          <SelectItem value="tfoot" disabled={!isBottomRowSelected}>
            {t("TableEditorStep7.inputs.group.labels.tfoot")}
          </SelectItem>
        </SelectContent>
      </Select>
    </TableEditorStep>
  );
}
